module.exports = __webpack_public_path__ + "static/media/Esophageal Varcies.34a51be9.webp";